export default {
  title: 'search',
  type: 'object',
  properties: {
    login: {
      type: 'string',
      title: 'Nazwa użytkownika',
      format: 'email',
      validationMessages: {
        format: 'Niepoprawny format adresu e-mail'
      }
    },
    phoneNumber: {
      type: 'string',
      title: 'Numer telefonu',
      maxLength: 500
    },
    pesel: {
      type: 'string',
      title: 'Numer PESEL',
      format: 'pesel',
      validationMessages: {
        format: 'Niepoprawny numer PESEL'
      }
    },
    cardNumber: {
      type: 'string',
      title: 'Numer karty',
      maxLength: 500
    }
  }
};
